import type { VisitType } from "~/services";
import type { AppointmentDetails } from "~/stores";
import type { StaffPatientInfoFormData } from "./utils/staff-booking-schemas";

export const STAFF_BOOKING_STEPS = {
  EMAIL: "email",
  VISIT_TYPE: "visitType",
  STATE_INSURANCE: "stateInsurance",
  PROVIDER_SELECTION: "providerSelection",
  COACH_PRICING: "coachPricing",
  SLOT: "slot",
  PATIENT_INFO: "patientInfo",
} as const;

export type StaffBookingStep =
  (typeof STAFF_BOOKING_STEPS)[keyof typeof STAFF_BOOKING_STEPS];

export interface StaffBookingData {
  email: string;
  visitType: VisitType | null;
  stateId: number | null;
  insuranceId: number | null;
  providerId: number | null;
  appointmentDetails: AppointmentDetails | null;
  patientInfo: Partial<StaffPatientInfoFormData> | null;
}
